// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".comment{background-color:#f8f9fa}.comment,.comment a{color:#495057}.comment-header{margin-bottom:1rem}.comment-header div:first-child{margin-bottom:.25rem;font-weight:700}.comment-content p{word-wrap:break-word}.comment-content iframe,.comment-content img{max-width:100%}.comment-content>p:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
